import { isTieredCalculation } from "../constants/commissionEnums";

const parseDate = (value) => {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

export const validateGroupForm = (form) => {
  const errors = {};
  if (!form.title?.trim()) errors.title = "عنوان الزامی است.";
  if (!form.code?.trim()) errors.code = "کد الزامی است.";

  const validFrom = parseDate(form.validFrom);
  const validTo = parseDate(form.validTo);
  if (!validFrom) errors.validFrom = "تاریخ شروع الزامی است.";
  if (validFrom && validTo && validTo < validFrom) {
    errors.validTo = "تاریخ پایان نمی‌تواند قبل از تاریخ شروع باشد.";
  }

  return errors;
};

export const validateTierOverlaps = (tiers) => {
  if (!tiers?.length) return null;

  const normalized = tiers
    .map((tier) => ({
      min:
        tier.minCapacityKw === "" || tier.minCapacityKw == null
          ? 0
          : Number(tier.minCapacityKw),
      max:
        tier.maxCapacityKw === "" || tier.maxCapacityKw == null
          ? Infinity
          : Number(tier.maxCapacityKw),
    }))
    .sort((a, b) => a.min - b.min);

  for (let i = 0; i < normalized.length; i += 1) {
    if (Number.isNaN(normalized[i].min) || Number.isNaN(normalized[i].max)) {
      return "مقادیر ظرفیت پله باید عدد معتبر باشند.";
    }
    if (normalized[i].max < normalized[i].min) {
      return "حداکثر ظرفیت هر پله نمی‌تواند کمتر از حداقل باشد.";
    }
    if (i > 0 && normalized[i].min <= normalized[i - 1].max) {
      return "بازه‌های ظرفیت پله‌ها نباید هم‌پوشانی داشته باشند.";
    }
  }

  return null;
};

export const validateRuleForm = (form) => {
  const errors = {};
  const calculationType = form.calculationType;

  if (!form.commissionGroupId) errors.commissionGroupId = "گروه پورسانتی الزامی است.";
  if (!form.title?.trim()) errors.title = "عنوان الزامی است.";
  if (!form.triggerEvent) errors.triggerEvent = "رویداد الزامی است.";
  if (!calculationType) errors.calculationType = "نوع محاسبه الزامی است.";

  const validFrom = parseDate(form.validFrom);
  const validTo = parseDate(form.validTo);
  if (!validFrom) errors.validFrom = "تاریخ شروع الزامی است.";
  if (validFrom && validTo && validTo < validFrom) {
    errors.validTo = "تاریخ پایان نمی‌تواند قبل از تاریخ شروع باشد.";
  }

  if (form.priority === "" || form.priority == null || Number(form.priority) < 0) {
    errors.priority = "اولویت باید عدد معتبر باشد.";
  }

  if (isTieredCalculation(calculationType)) {
    if (!form.tiers?.length) {
      errors.tiers = "حداقل یک پله تعریف کنید.";
    } else {
      const tierOverlapError = validateTierOverlaps(form.tiers);
      if (tierOverlapError) errors.tiers = tierOverlapError;

      form.tiers.forEach((tier, index) => {
        if (calculationType === "TieredFixedAmount") {
          if (tier.fixedAmount === "" || tier.fixedAmount == null) {
            errors[`tier_${index}_fixedAmount`] = "مبلغ ثابت پله الزامی است.";
          }
        }
        if (calculationType === "TieredPercentage") {
          if (tier.percentValue === "" || tier.percentValue == null) {
            errors[`tier_${index}_percentValue`] = "درصد پله الزامی است.";
          }
        }
      });
    }
  } else if (calculationType === "FixedAmount") {
    if (form.fixedAmount === "" || form.fixedAmount == null) {
      errors.fixedAmount = "مبلغ ثابت الزامی است.";
    }
  } else if (calculationType === "Percentage") {
    if (!form.percentBase) errors.percentBase = "مبنای درصد الزامی است.";
    if (form.percentValue === "" || form.percentValue == null) {
      errors.percentValue = "درصد الزامی است.";
    }
  } else if (calculationType === "TieredPercentage") {
    if (!form.percentBase) errors.percentBase = "مبنای درصد الزامی است.";
  }

  return errors;
};

export { formatLocalDateForApi as formatApiDate } from "../../../../middleware/middleware";

export const parseOptionalNumber = (value) => {
  if (value === "" || value == null) return null;
  const num = Number(value);
  return Number.isNaN(num) ? null : num;
};
